/** GET /api/v1/commerce/products 的查询参数。会话字段仅在传入时发送。 */
export type CommerceProductsQuery = {
  userId?: string;
  sessionId?: string;
  sessionVersion?: number;
  shopId: string;
  /** 页码，从 1 开始。 */
  pageNum: number;
  /** 每页条数，1 至 100。 */
  pageSize: number;
  /** 商品关键词，可选。 */
  keyword?: string;
};

/** 商品选择列表默认每页条数。 */
export const SHOP_PRODUCT_PAGE_SIZE = 5;

/** GET /api/v1/commerce/products 的 content 元素。 */
export type ShopProduct = {
  productId?: string;
  productName?: string;
  mainImageUrl?: string;
  /** 当前佣金比例（多为基点：1500 = 15%；≤100 时按百分数） */
  commissionRate?: number;
};

/** GET /api/v1/commerce/products 的 content。 */
export type ShopProductPage = {
  records?: ShopProduct[];
  total?: number;
  pageNum?: number;
  pageSize?: number;
};

/** 平台原始佣金 → 输入框百分数。 */
export function commissionRateToPercent(rate?: number | null): number | undefined {
  if (rate == null || !Number.isFinite(rate)) return undefined;
  return Math.abs(rate) > 100 ? rate / 100 : rate;
}

/** 输入框百分数 → 平台基点。 */
export function percentToCommissionRate(percent: number): number {
  return Math.round(percent * 100);
}
